import { Pipe, PipeTransform } from '@angular/core';
import { UserTypes } from '@shared/types/api-types';

@Pipe({
  name: 'userType',
})
export class UserTypePipe implements PipeTransform {
  transform(role: UserTypes): string {
    switch (role) {
      case 'CLIENT':
        return $localize`Госпиталь`;
      case 'DISTRIBUTOR':
        return $localize`Дистрибьютор`;
      case 'PDU_PERFORMER':
        return $localize`Исполнитель`;
      default:
        return '';
    }
  }
}
